import { defineComponent } from "vue";

import EmergencyPreparednessSection from "./Components/EmergencyPreparednessSection.vue";
import EvacuationSection from "./Components/EvacuationSection.vue";

export default defineComponent({
    components: {
        EmergencyPreparednessSection,
        EvacuationSection
    }
});
